export default __webpack_public_path__ + "static/media/PE_Logo-01.8fb99aa2.svg";